import {
  getColumnsConfig,
  getMobileColumnsConfig,
  getTextsConfig,
} from "./config";
import { getTableData, mapColumns } from "./mappers";

export function useSupportRequestsManagement() {
  return {
    columns: getColumnsConfig(),
    mobileColumns: getMobileColumnsConfig(),
    mapColumns,
    getTableData,
    texts: getTextsConfig(),
  };
}
